import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IApartmentState } from './apartment-state.store';

export const getters: GetterTree<IApartmentState, IRootState> = {
  apartments: (state: IApartmentState) => state.apartments,
  sidebarApartments: (state: IApartmentState) => state.sidebarApartments,
  apartmentParameter: (state: IApartmentState) => state.apartmentParameter,
  activityStatus: (state: IApartmentState) => state.activityStatus,
  currentApartment: (state: IApartmentState) => state.currentApartment,
  currentApartmentZone: (state: IApartmentState) => state.currentApartmentZone,
  apartment: (state: IApartmentState) => state.apartment,
  pagination: (state: IApartmentState) => state.pagination,
  service: (state: IApartmentState ) => state.service,
  apartmentCrudActionStatus: (state: IApartmentState ) => state.crudActionStatus,
  zoneAction: (state: IApartmentState) => state.zoneAction
}



// WEBPACK FOOTER //
// ./src/store/apartment/apartment-getters.store.ts